<sl-form-view [mainPageActions]="currentActions">
    @if (!!recordSummary()) {
        <mat-card>
            <mat-card-content class="container-max-width-100 ml-0">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="sender-type">
                            {{
                                recordSummary()!.outgoingAccountTypeIsBank
                                    ? ('Transactions.Bank' | translate)
                                    : ('Transactions.Shareholder' | translate)
                            }}
                        </div>
                        <div class="sender-name mb-3">
                            @if (!!recordSummary()!.outgoingId) {
                                <a [routerLink]="outgoingRouterLink">{{ recordSummary()!.outgoingName }}</a>
                            } @else {
                                {{ recordSummary()!.outgoingName }}
                            }
                        </div>
                        <div class="label mb-3">{{ 'Transactions.NumberOfShares' | translate }}</div>
                        <div>
                            <div class="row align-items-baseline text-right small-gutters">
                                <div class="col-2 label">{{ 'Transactions.Pieces' | translate }}</div>
                                <div class="col-2 initial-balance">{{ recordSummary()!.outgoingShareBalance | slNumber }}</div>
                                <div class="col-1 outgoing">-</div>
                                <div class="col-2 outgoing">{{ recordSummary()!.numberOfShares | slNumber }}</div>
                                <div class="col-2"><span class="material-icons flow-arrow">arrow_right_alt</span></div>
                                <div class="col-3 final-balance">
                                    {{ recordSummary()!.outgoingShareBalance - recordSummary()!.numberOfShares | slNumber }}
                                </div>
                            </div>
                            <div class="row align-items-baseline text-right small-gutters">
                                <div class="col-2 label">{{ 'Transactions.PercentageOfShares' | translate }}</div>
                                <div class="col-2 initial-balance">
                                    {{
                                        (recordSummary()!.outgoingShareBalance / recordSummary()!.securityTotalNumberOfShares) * 100
                                            | slNumber: 2
                                    }}
                                </div>

                                <div class="col-1 outgoing">-</div>
                                <div class="col-2 outgoing">
                                    {{
                                        (recordSummary()!.numberOfShares / recordSummary()!.securityTotalNumberOfShares) * 100 | slNumber: 2
                                    }}
                                </div>
                                <div class="col-2"><span class="material-icons flow-arrow">arrow_right_alt</span></div>
                                <div class="col-3 final-balance">
                                    {{
                                        ((recordSummary()!.outgoingShareBalance - recordSummary()!.numberOfShares)
                                            / recordSummary()!.securityTotalNumberOfShares)
                                            * 100 | slNumber: 2
                                    }}
                                    %
                                </div>
                            </div>
                            @if (!recordSummary()!.outgoingAccountTypeIsBank) {
                                <div class="row align-items-baseline text-right small-gutters">
                                    <div class="col-2 label">
                                        {{ 'ShareholderAccount.Skontro' | translate }}
                                    </div>
                                    <div class="col-2 numbers">
                                        {{ recordSummary()!.shareholderAccountSkontroNr }}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div class="col-lg-2 mt-lg-4 arrow text-center">
                        <svg width="47" height="16" viewBox="0 0 47 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.14937 7.6549L45.8929 7.6549M45.8929 7.6549L38.8402 0.602295M45.8929 7.6549L38.8402 14.7075"
                                stroke="#708087"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>

                    <div class="col-lg-5">
                        <div class="sender-type">
                            {{
                                recordSummary()!.incomingAccountTypeIsBank
                                    ? ('Transactions.Bank' | translate)
                                    : ('Transactions.Shareholder' | translate)
                            }}
                        </div>
                        <div class="sender-name mb-3">
                            @if (!!recordSummary()!.incomingId) {
                                <a [routerLink]="incomingRouterLink">{{ recordSummary()!.incomingName }}</a>
                            } @else {
                                {{ recordSummary()!.incomingName }}
                            }
                        </div>
                        <div class="label mb-3">{{ 'Transactions.NumberOfShares' | translate }}</div>
                        <div>
                            <div class="row align-items-baseline text-right small-gutters">
                                <div class="col-2 label">{{ 'Transactions.Pieces' | translate }}</div>
                                <div class="col-2 initial-balance">{{ recordSummary()!.incomingShareBalance | slNumber }}</div>
                                <div class="col-1 incoming">+</div>
                                <div class="col-2 incoming">{{ recordSummary()!.numberOfShares | slNumber }}</div>
                                <div class="col-2"><span class="material-icons flow-arrow">arrow_right_alt</span></div>
                                <div class="col-3 final-balance">
                                    {{ recordSummary()!.incomingShareBalance + recordSummary()!.numberOfShares | slNumber }}
                                </div>
                            </div>
                            <div class="row align-items-baseline text-right small-gutters">
                                <div class="col-2 label">{{ 'Transactions.PercentageOfShares' | translate }}</div>
                                <div class="col-2 initial-balance">
                                    {{
                                        (recordSummary()!.incomingShareBalance / recordSummary()!.securityTotalNumberOfShares) * 100
                                            | slNumber: 2
                                    }}
                                </div>

                                <div class="col-1 incoming">+</div>
                                <div class="col-2 incoming">
                                    {{
                                        (recordSummary()!.numberOfShares / recordSummary()!.securityTotalNumberOfShares) * 100 | slNumber: 2
                                    }}
                                </div>
                                <div class="col-2"><span class="material-icons flow-arrow">arrow_right_alt</span></div>
                                <div class="col-3 final-balance">
                                    {{
                                        ((recordSummary()!.incomingShareBalance + recordSummary()!.numberOfShares)
                                            / recordSummary()!.securityTotalNumberOfShares)
                                            * 100 | slNumber: 2
                                    }}
                                    %
                                </div>
                            </div>
                            @if (!recordSummary()!.incomingAccountTypeIsBank) {
                                <div class="row align-items-baseline text-right small-gutters">
                                    <div class="col-2 label">
                                        {{ 'ShareholderAccount.Skontro' | translate }}
                                    </div>
                                    <div class="col-2 numbers">
                                        {{ recordSummary()!.shareholderAccountSkontroNr }}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <hr class="divider mt-3 mb-3" />

                <div class="row">
                    <div class="col-12">
                        <h3>
                            {{
                                recordSummary()!.outgoingAccountTypeIsBank
                                    ? ('Transactions.ShareRegisterEntry' | translate)
                                    : ('Transactions.ShareRegisterRemoval' | translate)
                            }}
                        </h3>
                        <div class="row">
                            <div class="col-4 col-md-2 label">
                                {{ 'Transactions.Shares' | translate }}
                            </div>
                            <div class="col-8 col-md-10 mat-subtitle-2">
                                {{ recordSummary()!.numberOfShares | slNumber }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 col-md-2 label">
                                {{ 'Transactions.SecurityName' | translate }}
                            </div>
                            <div class="col-8 col-md-10 mat-subtitle-2">
                                {{ recordSummary()!.securityName }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 col-md-2 label">
                                {{ 'Transactions.ValueDate' | translate }}
                            </div>
                            <div class="col-8 col-md-10 mat-subtitle-2">
                                {{ recordSummary()!.valueDate | localizedDate: 'shortDate' }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 col-md-2 label">
                                {{ 'Transactions.OutgoingId' | translate }}
                            </div>
                            <div class="col-8 col-md-10 mat-subtitle-2">
                                {{ recordSummary()!.id }}
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    }
</sl-form-view>
